import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { PrimaryButton, Field, inputCls } from "@/components/ui-kit";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState("");

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setSubmitting(true);
    try { await login(email.trim().toLowerCase(), password); nav("/admin"); }
    catch (ex) {
      const d = ex?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Invalid email or password");
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] px-6" data-testid="admin-login-page">
      <div className="absolute inset-0 bg-[radial-gradient(40%_60%_at_50%_50%,rgba(59,130,246,0.12),transparent_60%)] pointer-events-none" />
      <motion.div
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="relative w-full max-w-md"
      >
        <div className="rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-xl p-8 md:p-10">
          <div className="w-10 h-10 rounded-lg bg-[#3B82F6]/10 border border-[#3B82F6]/30 flex items-center justify-center">
            <Lock className="w-5 h-5 text-[#3B82F6]" />
          </div>
          <h1 className="mt-6 font-display text-3xl tracking-tight">Admin sign in</h1>
          <p className="mt-2 text-sm text-[#9CA3AF]">GK Fleet operations console.</p>
          <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="admin-login-form">
            <Field label="Email">
              <input data-testid="admin-email" required type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
            </Field>
            <Field label="Password">
              <input data-testid="admin-password" required type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
            </Field>
            {err && <p data-testid="admin-login-error" className="text-sm text-red-400">{err}</p>}
            <PrimaryButton data-testid="admin-login-submit" disabled={submitting} className="w-full">
              {submitting ? "Signing in…" : "Sign in"}
            </PrimaryButton>
          </form>
        </div>
      </motion.div>
    </div>
  );
}
